(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-upgrade-card"] && !Shopify.designMode) return;
  try {
    // Handle bundle upgrade button clicks
  document.addEventListener('click', function(e) {
    const upgradeBtn = e.target.closest('[data-bundle-upgrade]');
    if (!upgradeBtn) return;
    
    e.preventDefault();
    
    const bundleVariantId = upgradeBtn.getAttribute('data-bundle-upgrade');
    if (!bundleVariantId) return;
    
    // Use CartManager if available
    if (window.CartManager && window.CartManager.isInitialized()) {
      window.CartManager.handleBundleUpgrade(bundleVariantId);
    }
  });

  // Show/hide upgrade card based on cart state from CartManager
  function updateUpgradeCardVisibility() {
    const upgradeCard = document.querySelector('.bundle-upgrade-card');
    if (!upgradeCard) return;

    // Check if CartManager is available and initialized
    if (!window.CartManager || !window.CartManager.isInitialized()) {
      upgradeCard.style.display = 'none';
      return;
    }

    const cart = window.CartManager.getCart();
    if (!cart) {
      upgradeCard.style.display = 'none';
      return;
    }

    // Use CartManager's logic to determine if upgrade should be shown
    if (window.CartManager.shouldShowBundleUpgrade(cart)) {
      upgradeCard.style.display = '';
    } else {
      upgradeCard.style.display = 'none';
    }
  }

  // Listen to cart events from CartManager
  document.addEventListener('cart:fetched', updateUpgradeCardVisibility);
  document.addEventListener('cart:item-added', updateUpgradeCardVisibility);
  document.addEventListener('cart:quantity-changed', updateUpgradeCardVisibility);
  document.addEventListener('cart:item-removed', updateUpgradeCardVisibility);
  document.addEventListener('cart:drawer-opened', updateUpgradeCardVisibility);

  // Initial check
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateUpgradeCardVisibility);
  } else {
    updateUpgradeCardVisibility();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-text-card"] && !Shopify.designMode) return;
  try {
    (function() {
    function initImageTextCard(card) {
      if (card.dataset.itcInit === '1') return;
      

      card.dataset.itcInit = '1';

      const btn = card.querySelector('.image-text-card__play-btn');
      const media = card.querySelector('.image-text-card__video');
      const scrim = card.querySelector('.image-text-card__scrim');
      if (! btn || ! media || ! scrim) return;
      


      const type = media.dataset.videoType;
      const HIDE_DELAY = 1000; // 1s auto-hide
      let hideTimer = null;
      let isPointerOver = false;

      const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches || ('ontouchstart' in window);

      function showBtn() {
        btn.classList.remove('is-hidden');
      }
      function hideBtn() {
        btn.classList.add('is-hidden');
      }
      function showScrim() {
        scrim.classList.remove('is-hidden');
      }
      function hideScrim() {
        scrim.classList.add('is-hidden');
      }

      function setOverlayVisible(visible) {
        if (visible) {
          showBtn();
          showScrim();
        } else {
          hideBtn();
          hideScrim();
        }
      }

      function clearHideTimer() {
        if (hideTimer) {
          clearTimeout(hideTimer);
          hideTimer = null;
        }
      }
      function scheduleAutoHideIfPlaying() {
        clearHideTimer();
        if (card.classList.contains('is-playing')) {
          hideTimer = setTimeout(() => setOverlayVisible(false), HIDE_DELAY);
        }
      }

// Playback state tracking
      if (type === 'file' && media.tagName === 'VIDEO') {
        media.addEventListener('play', function() {
          card.classList.add('is-playing', 'video-visible');
          if (isTouch) {
            setOverlayVisible(true);
            scheduleAutoHideIfPlaying();
          } else {
            setOverlayVisible(isPointerOver);
            if (! isPointerOver) 
              scheduleAutoHideIfPlaying();
            

          }
        });
        media.addEventListener('pause', function() {
          card.classList.remove('is-playing');
          clearHideTimer();
          setOverlayVisible(true);
        });
        media.addEventListener('ended', function() {
          card.classList.remove('is-playing');
          clearHideTimer();
          setOverlayVisible(true);
        });
      }

      function ytCommand(frame, command) {
        if (! frame || ! frame.contentWindow) return;
        

        frame.contentWindow.postMessage(JSON.stringify({event: 'command', func: command, args: []}), '*');
      }
      function vimeoCommand(frame, method) {
        if (! frame || ! frame.contentWindow) return;
        

        frame.contentWindow.postMessage(JSON.stringify({method}), '*');
      }

      function subscribeYouTube(frame) {
        try {
          frame.contentWindow.postMessage(JSON.stringify({
            event: 'listening',
            id: 'itc-' + Math.random()
          }), '*');
          frame.contentWindow.postMessage(JSON.stringify({event: 'command', func: 'addEventListener', args: ['onStateChange']}), '*');
        } catch (e) {}
      }
      function subscribeVimeo(frame) {
        try {
          frame.contentWindow.postMessage(JSON.stringify({method: 'addEventListener', value: 'play'}), '*');
          frame.contentWindow.postMessage(JSON.stringify({method: 'addEventListener', value: 'pause'}), '*');
          frame.contentWindow.postMessage(JSON.stringify({method: 'addEventListener', value: 'ended'}), '*');
        } catch (e) {}
      }
      if (type === 'youtube' && media.tagName === 'IFRAME') {
        media.addEventListener('load', () => subscribeYouTube(media));
        setTimeout(() => subscribeYouTube(media), 1000);
      }
      if (type === 'vimeo' && media.tagName === 'IFRAME') {
        media.addEventListener('load', () => subscribeVimeo(media));
        setTimeout(() => subscribeVimeo(media), 1000);
      }

// Button: play/pause only (doesn't toggle overlay visibility)
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (type === 'file' && media.tagName === 'VIDEO') {
          if (media.paused) 
            media.play();
           else 
            media.pause();
          

        } else if (type === 'youtube' && media.tagName === 'IFRAME') {
          ytCommand(
            media,
            card.classList.contains('is-playing')
              ? 'pauseVideo'
              : 'playVideo'
          );
        } else if (type === 'vimeo' && media.tagName === 'IFRAME') {
          vimeoCommand(
            media,
            card.classList.contains('is-playing')
              ? 'pause'
              : 'play'
          );
        } else {
          try {
            const url = new URL(media.src);
            url.searchParams.set('autoplay', '1');
            media.src = url.toString();
          } catch (e) {}
        }
      });

// Mobile: tap video area (scrim) to toggle play/pause and manage overlay auto-hide
      scrim.addEventListener('click', function(e) {
        e.stopPropagation();
        if (card.classList.contains('is-playing')) { // toggle pause
          if (type === 'file' && media.tagName === 'VIDEO') 
            media.pause();
           else if (type === 'youtube') 
            ytCommand(media, 'pauseVideo');
           else if (type === 'vimeo') 
            vimeoCommand(media, 'pause');
          


// overlay will show via pause handler
        } else { // play and schedule hide
          if (type === 'file' && media.tagName === 'VIDEO') 
            media.play();
           else if (type === 'youtube') 
            ytCommand(media, 'playVideo');
           else if (type === 'vimeo') 
            vimeoCommand(media, 'play');
          


// show briefly, then auto-hide
          setOverlayVisible(true);
          scheduleAutoHideIfPlaying();
        }
      });

// Desktop: show on hover while playing; keep visible when paused
      card.addEventListener('pointerenter', () => {
        if (isTouch) return;
        

        isPointerOver = true;
        if (card.classList.contains('is-playing')) {
          clearHideTimer();
        }
        setOverlayVisible(true);
      });
      card.addEventListener('pointerleave', () => {
        if (isTouch) return;
        

        isPointerOver = false;
        if (card.classList.contains('is-playing')) {
          scheduleAutoHideIfPlaying();
        } else {
          setOverlayVisible(true); // paused => keep visible
        }
      });

// Sync state from providers
      window.addEventListener('message', (event) => {
        const iframes = card.querySelectorAll('iframe.image-text-card__video');
        let fromThisCard = false;
        for (const f of iframes) {
          if (f.contentWindow === event.source) {
            fromThisCard = true;
            break;
          }
        }
        if (! fromThisCard) return;
        


        try {
          const data = typeof event.data === 'string'
            ? JSON.parse(event.data)
            : event.data;

// YouTube
          if (data && data.event === 'onStateChange') {
            if (data.info === 1) {
              card.classList.add('is-playing', 'video-visible');
              if (isTouch) {
                setOverlayVisible(true);
                scheduleAutoHideIfPlaying();
              } else {
                setOverlayVisible(isPointerOver);
                if (! isPointerOver) 
                  scheduleAutoHideIfPlaying();
                

              }
            } else if (data.info === 2 || data.info === 0) {
              card.classList.remove('is-playing');
              clearHideTimer();
              setOverlayVisible(true);
            }
          }

// Vimeo
          if (data && (data.event === 'play' || data.event === 'pause' || data.event === 'ended')) {
            if (data.event === 'play') {
              card.classList.add('is-playing', 'video-visible');
              if (isTouch) {
                setOverlayVisible(true);
                scheduleAutoHideIfPlaying();
              } else {
                setOverlayVisible(isPointerOver);
                if (! isPointerOver) 
                  scheduleAutoHideIfPlaying();
                

              }
            } else {
              card.classList.remove('is-playing');
              clearHideTimer();
              setOverlayVisible(true);
            }
          }
        } catch (e) {}
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.image-text-card[data-has-video="true"]').forEach(initImageTextCard);
    }

    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
    document.addEventListener('shopify:section:load', function(e) {
      initAll(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Product Card Functionality
  document.addEventListener('DOMContentLoaded', function() {

// Quantity selector functionality
    document.querySelectorAll('.product-card__qty-btn').forEach(button => {
      button.addEventListener('click', function() {
        const input = this.parentNode.querySelector('.product-card__qty-input');
        const hiddenInput = this.closest('.product-card__content').querySelector('.product-card__quantity-hidden');
        let currentValue = parseInt(input.value);

        if (this.classList.contains('product-card__qty-btn--plus')) {
          if (currentValue < 300) {
            currentValue++;
          }
        } else if (this.classList.contains('product-card__qty-btn--minus')) {
          if (currentValue > 1) {
            currentValue--;
          }
        }

        input.value = currentValue;
        if (hiddenInput) {
          hiddenInput.value = currentValue;
        }
      });
    });

// Size selector functionality + swap product/variant and price
    document.querySelectorAll('.product-card__size-btn').forEach(button => {
      button.addEventListener('click', function() {
        const container = this.closest('.product-card');
        const options = this.closest('.product-card__size-options');
        if (! container || ! options) return;
        


// Toggle active state
        options.querySelectorAll('.product-card__size-btn').forEach(btn => btn.classList.remove('product-card__size-btn--active'));
        this.classList.add('product-card__size-btn--active');

// Update hidden variant id
        const variantId = this.getAttribute('data-product-id');
        const form = container.querySelector('.product-card__form');
        const idInput = form?.querySelector('input[name="id"]');
        if (variantId && idInput) {
          idInput.value = variantId;
        }

// Update visible price on buttons
// Update the price element inside the clicked button if exists (money-formatted)
        const money = this.getAttribute('data-price-money');
        const compareMoney = this.getAttribute('data-compare-price-money');
        const priceEl = this.querySelector('.product-card__size-price');
        const comparePriceEl = this.querySelector('.product-card__size-price-compare');
        
        if (money && priceEl) {
          priceEl.textContent = '';
          priceEl.insertAdjacentHTML('beforeend', money);
        }
        
        if (compareMoney && comparePriceEl) {
          comparePriceEl.textContent = '';
          comparePriceEl.insertAdjacentHTML('beforeend', compareMoney);
        }

        // (Section-level script handles carousel sync; no cross-snippet events)
      });
    });

// Buy now button functionality
    document.querySelectorAll('.product-card__buy-now').forEach(button => {
      button.addEventListener('click', async function() {
        const container = this.closest('.product-card');
        const form = container?.querySelector('.product-card__form');
        const idInput = form?.querySelector('input[name="id"]');
        const quantityInput = form?.querySelector('.product-card__quantity-hidden');
        const variantId = idInput?.value;
        const quantity = quantityInput
          ? parseInt(quantityInput.value) || 1
          : 1;

        if (! variantId) {
          window.location.href = '/checkout';
          return;
        }

        try { // Use CartManager if available, fallback to direct fetch
          if (window.CartManager && window.CartManager.isInitialized()) {
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', quantity);
            await window.CartManager.addToCart(formData);
          } else { // Fallback to direct fetch
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(
                {id: variantId, quantity}
              )
            });
          }
        } catch (e) { // ignore and still attempt checkout
        }window.location.href = '/checkout';
      });
    });
  });

// Add to cart form functionality
  document.querySelectorAll('.product-card__form').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const button = form.querySelector('.product-card__add-to-cart');
      const buttonText = button.querySelector('.btn__text');
      const buttonLoading = button.querySelector('.btn__loading');
      const quantityInput = form.querySelector('.product-card__quantity-hidden');

// Show loading state
      buttonText.style.display = 'none';
      buttonLoading.style.display = 'inline';
      button.disabled = true;

      try { // Use CartManager if available, fallback to direct fetch
        if (window.CartManager && window.CartManager.isInitialized()) {
          const formData = new FormData(form);
          await window.CartManager.addToCart(formData);

// Show success feedback
          setTimeout(() => {
            buttonText.textContent = 'Sepete Ekle';
          }, 2000);
        } else { // Fallback to direct fetch
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(
              {
                id: form.querySelector('input[name="id"]').value,
                quantity: quantityInput
                  ? quantityInput.value
                  : 1
              }
            )
          });

          if (! response.ok) 
            throw new Error('Add to cart failed');
          


// Show success feedback
          setTimeout(() => {
            buttonText.textContent = 'Sepete Ekle';
          }, 2000);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);

// Show error feedback
        buttonText.textContent = 'Error!';
        setTimeout(() => {
          buttonText.textContent = 'Sepete Ekle';
        }, 2000);
      } finally { // Reset button state
        buttonText.style.display = 'inline';
        buttonLoading.style.display = 'none';
        button.disabled = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const init = function() {
      const $ = window.jQuery;
      if (! $) return;

      const wrappers = document.querySelectorAll('.product-carousel');
      if (!wrappers.length) return;

      wrappers.forEach(function(wrapper) {
        const element = wrapper.querySelector('#product-carousel');
        if (! element) return;

        const $carousel = $(element);
        if ($carousel.data('owl-initialized')) return;

        $carousel.data('owl-initialized', true);
        const ds = element.dataset || {};
        const parseNum = (v, d) => {
          const n = parseInt(v);
          return isNaN(n)
            ? d
            : n;
        };
        const parseBool = (v) => v === true || v === 'true';
        const gap = parseNum(ds.margin || ds.gap, 16);
        const items = parseNum(ds.items, 1);
        $carousel.owlCarousel({
          items: items,
          loop: parseBool(ds.loop) || true,
          margin: gap,
          stagePadding: parseNum(ds.stagePadding, 0),
          autoWidth: true,
          nav: parseBool(ds.nav),
          dots: parseBool(ds.dots),
          autoplay: false,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          center: false
        });
      
        window.addEventListener('load', function() {
          try {
            $carousel.trigger('refresh.owl.carousel');
          } catch (e) {}
        });
      });
    };
    if (typeof window.jQuery === 'undefined') {
      window.addEventListener('load', init);
    } else {
      init();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["review-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const init = function() {
      const $ = window.jQuery;
      if (! $) return;
      


      const element = document.getElementById('review-carousel');
      if (! element) return;
      


      const $carousel = $(element);
      if ($carousel.data('owl-initialized')) return;
      


      $carousel.data('owl-initialized', true);
      const ds = element.dataset || {};
      const parseNum = (v, d) => {
        const n = parseInt(v);
        return isNaN(n)
          ? d
          : n;
      };
      const parseBool = (v) => v === true || v === 'true';
      const gap = parseNum(ds.margin || ds.gap, 16);
      const items = parseNum(ds.items, 1);

      $carousel.owlCarousel({
        items: 1,
        loop: parseBool(ds.loop) || true,
        margin: gap,
        stagePadding: parseNum(ds.stagePadding, 0),
        autoWidth: false,
        nav: parseBool(ds.nav),
        dots: parseBool(ds.dots),
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        center: false
      });

      window.addEventListener('load', function() {
        try {
          $carousel.trigger('refresh.owl.carousel');
        } catch (e) {}
      });
    };
    if (typeof window.jQuery === 'undefined') {
      window.addEventListener('load', init);
    } else {
      init();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-carousel"] && !Shopify.designMode) return;
  try {
    // Owl init (unchanged) + minimal video wiring: centered button, no dark overlay, 1s auto-hide
  document.addEventListener('DOMContentLoaded', function() {
    const init = function() {
      const $ = window.jQuery;
      if (! $) return;
      


      const element = document.getElementById('video-carousel');
      if (! element) return;
      


      const $carousel = $(element);
      if ($carousel.data('owl-initialized')) return;
      


      $carousel.data('owl-initialized', true);

      const ds = element.dataset || {};
      const parseNum = (v, d) => {
        const n = parseInt(v);
        return isNaN(n)
          ? d
          : n;
      };
      const parseBool = (v) => v === true || v === 'true';
      const gap = parseNum(ds.margin || ds.gap, 16);
      const items = parseNum(ds.items, 4);
      const itemsTablet = parseNum(ds.itemsTablet, 3);
      const itemsMobile = parseNum(ds.itemsMobile, 1);

      $carousel.owlCarousel({
        items: items,
        loop: parseBool(ds.loop),
        margin: gap,
        stagePadding: parseNum(ds.stagePadding, 0),
        autoWidth: false,
        nav: parseBool(ds.nav),
        dots: parseBool(ds.dots),
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        center: false,
        responsive: {
          0: {
            items: itemsMobile,
            margin: gap
          },
          600: {
            items: itemsTablet,
            margin: gap
          },
          900: {
            items: items,
            margin: gap
          }
        }
      });

// ---------- Minimal additions: play/pause + overlay behavior ----------
      const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches || ('ontouchstart' in window);
      const HIDE_DELAY = 1000; // 1s as requested
      const wired = new WeakSet();
      const hideTimers = new WeakMap();

      function stopOwlDrag(e) {
        e.stopPropagation();
      }

      function setOverlayVisible(item, visible) {
        const btn = item.querySelector('.vc-play-btn');
        if (! btn) return;
        


        btn.classList.toggle('is-hidden', ! visible);
      }

      function clearHide(item) {
        const t = hideTimers.get(item);
        if (t) {
          clearTimeout(t);
          hideTimers.delete(item);
        }
      }

      function scheduleHide(item) {
        clearHide(item);
        if (! item.classList.contains('is-playing')) return;
        


        if (! isTouch && item.matches(':hover')) return;
        


// desktop: don't hide while hovered
        const t = setTimeout(() => setOverlayVisible(item, false), HIDE_DELAY);
        hideTimers.set(item, t);
      }

      function setPlaying(item, playing) {
        item.classList.toggle('is-playing', !! playing);
        if (playing) {
          item.classList.add('video-visible');
          if (isTouch) {
            setOverlayVisible(item, true);
            scheduleHide(item);
          } else {
            setOverlayVisible(item, item.matches(':hover'));
            if (! item.matches(':hover')) 
              scheduleHide(item);
            


          }
        } else {
          clearHide(item);
          setOverlayVisible(item, true);
        }
      }

      function play(item, media) {
        const type = media.dataset.videoType;
        item.classList.add('video-visible');
        if (type === 'file' && media.tagName === 'VIDEO') {
          try {
            media.play();
          } catch (e) {}setPlaying(item, true);
          return;
        }
        if (type === 'youtube' && media.tagName === 'IFRAME') {
          media.contentWindow ?. postMessage(JSON.stringify({event: 'command', func: 'playVideo', args: []}), '*');
          setPlaying(item, true);
          return;
        }
        if (type === 'vimeo' && media.tagName === 'IFRAME') {
          media.contentWindow ?. postMessage(JSON.stringify({method: 'play'}), '*');
          setPlaying(item, true);
          return;
        }
        try {
          const u = new URL(media.src);
          u.searchParams.set('autoplay', '1');
          media.src = u.toString();
          setPlaying(item, true);
        } catch (e) {}
      }

      function pause(item, media) {
        const type = media.dataset.videoType;
        if (type === 'file' && media.tagName === 'VIDEO') {
          try {
            media.pause();
          } catch (e) {}setPlaying(item, false);
          return;
        }
        if (type === 'youtube' && media.tagName === 'IFRAME') {
          media.contentWindow ?. postMessage(JSON.stringify({event: 'command', func: 'pauseVideo', args: []}), '*');
          setPlaying(item, false);
          return;
        }
        if (type === 'vimeo' && media.tagName === 'IFRAME') {
          media.contentWindow ?. postMessage(JSON.stringify({method: 'pause'}), '*');
          setPlaying(item, false);
          return;
        }
        setPlaying(item, false);
      }

      function togglePlay(item, media) {
        if (item.classList.contains('is-playing')) 
          pause(item, media);
         else 
          play(item, media);
        


      }

      function subscribeYouTube(frame) {
        try {
          frame.contentWindow ?. postMessage(JSON.stringify({
            event: 'listening',
            id: 'vc-' + Math.random()
          }), '*');
          frame.contentWindow ?. postMessage(JSON.stringify({event: 'command', func: 'addEventListener', args: ['onStateChange']}), '*');
        } catch (e) {}
      }
      function subscribeVimeo(frame) {
        try {
          frame.contentWindow ?. postMessage(JSON.stringify({method: 'addEventListener', value: 'play'}), '*');
          frame.contentWindow ?. postMessage(JSON.stringify({method: 'addEventListener', value: 'pause'}), '*');
          frame.contentWindow ?. postMessage(JSON.stringify({method: 'addEventListener', value: 'ended'}), '*');
        } catch (e) {}
      }

      function wireItem(item) {
        if (wired.has(item)) return;
        


        const media = item.querySelector('.vc-media');
        const btn = item.querySelector('.vc-play-btn');
        const scrim = item.querySelector('.vc-scrim');
        if (! media || ! btn || ! scrim) {
          wired.add(item);
          return;
        }
        wired.add(item);

// Prevent Owl drag when interacting with media/button/scrim
        ['pointerdown', 'mousedown', 'touchstart'].forEach(evt => {
          media.addEventListener(evt, stopOwlDrag);
          btn.addEventListener(evt, stopOwlDrag);
          scrim.addEventListener(evt, stopOwlDrag);
        });
        media.addEventListener('dragstart', (e) => e.preventDefault());

// Button toggles play/pause
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          togglePlay(item, media);
        });

// Scrim toggles play/pause (transparent, full-card)
        scrim.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          togglePlay(item, media);
        });

// HTML5 <video>: sync with native play/pause/ended
        if (media.dataset.videoType === 'file' && media.tagName === 'VIDEO') {
          media.addEventListener('play', () => setPlaying(item, true));
          media.addEventListener('pause', () => setPlaying(item, false));
          media.addEventListener('ended', () => setPlaying(item, false));
        }

// Provider subscriptions
        if (media.dataset.videoType === 'youtube' && media.tagName === 'IFRAME') {
          media.addEventListener('load', () => subscribeYouTube(media));
          setTimeout(() => subscribeYouTube(media), 800);
        }
        if (media.dataset.videoType === 'vimeo' && media.tagName === 'IFRAME') {
          media.addEventListener('load', () => subscribeVimeo(media));
          setTimeout(() => subscribeVimeo(media), 800);
        }

// Desktop hover behavior while playing
        if (! isTouch) {
          item.addEventListener('pointerenter', () => {
            if (item.classList.contains('is-playing')) {
              clearHide(item);
              setOverlayVisible(item, true);
            }
          });
          item.addEventListener('pointerleave', () => {
            if (item.classList.contains('is-playing')) {
              scheduleHide(item);
            }
          });
        }
      }

      function wireAll() {
        element.querySelectorAll('.owl-item .item').forEach(wireItem);
      }
      wireAll();
      $carousel.on('initialized.owl.carousel refreshed.owl.carousel translated.owl.carousel', wireAll);

// Sync with provider postMessages
      window.addEventListener('message', (event) => {
        const frames = element.querySelectorAll('iframe.vc-media');
        let owner = null;
        for (const f of frames) {
          if (f.contentWindow === event.source) {
            owner = f;
            break;
          }
        }
        if (! owner) return;
        


        const item = owner.closest('.item');
        if (! item) return;
        


        try {
          const data = typeof event.data === 'string'
            ? JSON.parse(event.data)
            : event.data;
          if (data && data.event === 'onStateChange') { // YouTube
            if (data.info === 1) 
              setPlaying(item, true);
            


            if (data.info === 2 || data.info === 0) 
              setPlaying(item, false);
            


          }
          if (data && (data.event === 'play' || data.event === 'pause' || data.event === 'ended')) { // Vimeo
            if (data.event === 'play') 
              setPlaying(item, true);
             else 
              setPlaying(item, false);
            


          }
        } catch (e) {}
      });

// ---------- end minimal additions ----------
    };

    if (typeof window.jQuery === 'undefined') {
      window.addEventListener('load', init);
    } else {
      init();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
